import { render, staticRenderFns } from "./PhaseEditor.vue?vue&type=template&id=4f2690c0&scoped=true&"
import script from "./PhaseEditor.vue?vue&type=script&lang=js&"
export * from "./PhaseEditor.vue?vue&type=script&lang=js&"
import style0 from "./PhaseEditor.vue?vue&type=style&index=0&id=4f2690c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2690c0",
  null
  
)

export default component.exports